import { Typography } from 'antd'
import React, { FunctionComponent, memo } from 'react'
import { UseQueryState } from 'urql'

import { AUCTION_TYPES } from '../../../common/auctionScrapeTypes'
import { AuctionDetailDrawerQuery } from '../../../graphql/generated'
import { AuctionDetailDrawerInfo } from '../AuctionDetailDrawerInfo/AuctionDetailDrawerInfo'
import { AuctionDetailDrawerTitle } from '../AuctionDetailDrawerTitle/AuctionDetailDrawerTitle'
import { AuctionMonitoringLinkedPropertyTableContainer } from '../AuctionMonitoringLinkedPropertyTableContainer/AuctionMonitoringLinkedPropertyTableContainer'
import { AuctionMonitoringTilesItemImage as _AuctionDetailDrawerImage } from '../AuctionMonitoringTilesItemImage/AuctionMonitoringTilesItemImage'
import { CadastreMapDetailDrawerFetchError } from '../CadastreMapDetailDrawerFetchError/CadastreMapDetailDrawerFetchError'
import { DetailDrawerPropertySkeleton } from '../DetailDrawerPropertySkeleton/DetailDrawerPropertySkeleton'

export interface AuctionDetailDrawerBodyProps {
  dataSource: UseQueryState<AuctionDetailDrawerQuery>
}

const { Title } = Typography

export const AuctionDetailDrawerBody: FunctionComponent<AuctionDetailDrawerBodyProps> =
  memo(({ dataSource }) => {
    const auction = dataSource.data?.auctionListingById

    if (dataSource.fetching && !auction) return <DetailDrawerPropertySkeleton />
    if (dataSource.error || !auction)
      return <CadastreMapDetailDrawerFetchError />

    return (
      <div className="flex flex-col space-y-3 mb-4">
        <AuctionDetailDrawerTitle
          title={auction.title}
          detailUrl={auction.detailUrl}
          auction={auction}
        />

        <_AuctionDetailDrawerImage
          auctionId={auction.id}
          auctionType={auction.type as AUCTION_TYPES}
          lat={auction.lat}
          long={auction.long}
          photoUrl={auction.photoUrl}
          className="min-h-[450px]"
          auctionUrl={auction.detailUrl}
        />

        <AuctionDetailDrawerInfo auction={auction} />

        <div className="w-full !mt-8">
          <Title level={4}>Přiřazené nemovitosti</Title>
          <AuctionMonitoringLinkedPropertyTableContainer
            viewType="drawer"
            auctionId={auction.id}
          />
        </div>
      </div>
    )
  })
